import { forwardRef, HTMLProps } from 'react';
import { AppIcon } from 'Modules/Plans/components/ApplicationBadge/ApplicationBadge';
import { Image } from '@round/ui-kit';
import styles from './CampaignImage.module.css';
import { applicationManager, creatorbase } from '@round/api';
import cn from 'classnames';
import PlatformIcon from 'Modules/Plans/components/PlatformIcon';

type Props = HTMLProps<HTMLDivElement> & {
    imageUrl: string | null;
    managedBy: applicationManager.Application | null;
    platform: creatorbase.Platform | null;
    isLoading?: boolean;
};

const CampaignImage = forwardRef<HTMLDivElement, Props>(
    ({ imageUrl, managedBy, className, isLoading, platform, ...props }, ref) => {
        return (
            <div className={cn(className, styles.container)} ref={ref} {...props}>
                <Image className={styles.image} src={imageUrl ?? ''} loading={isLoading} skeletonCircle={false} />
                {!isLoading && platform && (
                    <div className={styles.iconContainer}>
                        <PlatformIcon platform={platform} colored className={styles.platformIcon} />
                    </div>
                )}
                {!isLoading && (managedBy === 'round' || managedBy === 'microwave') && (
                    <div className={styles.iconContainer}>
                        <AppIcon application={managedBy} className={styles.appIcon} />
                    </div>
                )}
            </div>
        );
    }
);

export default CampaignImage;
